import React, { FC, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { linkHandler } from 'utils/linkHandler';
import Style from './LibraryNavItem.style';

type TProps = {
  title: string;
  slug: string;
  type: 'active' | 'inactive';
};

export const LibraryNavItem: FC<TProps> = ({ title, type, slug }) => {
  const accessibilityProps = useMemo(() => {
    const _accessibilityProps: Record<string, unknown> = {};
    if (type === 'active') {
      _accessibilityProps['aria-current'] = 'page';
    }
    return _accessibilityProps;
  }, [type]);

  return (
    <Style className={'library-nav-item library-nav-item--' + type}>
      <Link {...accessibilityProps} to={slug ? linkHandler.get('category', { slug }) : linkHandler.get('library')}>
        {title}
      </Link>
    </Style>
  );
};
